<template>
	<div class="wspro-resources-listing">
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/resources">Resources</router-link>
		</div>
		<h3>All Resources</h3>
		<div id="resources-wrapper">
			<div id="resources-sections">
				<b-tabs align="center" pills v-model="activeTab">
					<b-tab v-for="section in sections" :key="section.slug" :title-item-class="section.slug">
						<template #title>
							<div class="section-heading">
								<span class="section-image"></span>
								<span class="section-name">{{ section.name }}</span>
							</div>
						</template>
						<resources-list :resource="section.slug" :resource-data="index[section.postType]"></resources-list>
					</b-tab>
				</b-tabs>
			</div>
		</div>
	</div>
</template>

<script>
import ResourcesList from "@/pages/resources/ResourcesList";

export default {
	name: "ResourcesIndex",
	components: { ResourcesList },
	data() {
		return {
			pageParams: {
				pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 24},
				search: {val: ""},
				filters: {}
			},
			errors: {},
			sections: {
				guides: {
					name:		'Guides & Downloads',
					slug:		'guides-and-downloads',
					postType:	'ws_guide'
				},
				walkthroughs: {
					name:		'Walkthroughs',
					slug:		'walkthroughs',
					postType:	'ws_walkthrough'
				}
			}
		}
	},
	methods: {
		getPage(params) {
			this.getPageHandler({
				waitName: 'resources.index',
				action: 'fetchResources', // vuex action
				pageParams: this.pageParams,
				isInit: params ? params.init : false, // parse from url query params
				pushRoute: true, // push pagination params and search q to route
				resetPagination: params ? params.resetPagination : false // new search input -> need to reset page & sorting
			});
		},
	},
	mounted() {
		this.getPage({ init: true });
	},
	computed: {
		index() {
			return this.$store.state.resources.index;
		},
		activeTab: {
			get() {
				return this.$store.state.resources.activeTab;
			},
			set(newTab) {
				this.$store.commit('changeActiveTab', newTab);
			}
		}
	}
}
</script>

<style>
</style>
